"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeLinkSchemaPropTypes", {
  enumerable: true,
  get: function get() {
    return _schema.makeLinkSchemaPropTypes;
  }
});
Object.defineProperty(exports, "LinkProps", {
  enumerable: true,
  get: function get() {
    return _types.LinkProps;
  }
});
Object.defineProperty(exports, "linkColorStyles", {
  enumerable: true,
  get: function get() {
    return _styles.linkColorStyles;
  }
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _propTypes2 = require("@decisiv/prop-types");

var _schema = _interopRequireWildcard(require("./schema"));

var _Link = _interopRequireDefault(require("./Link"));

var _types = require("./types");

var _styles = require("./styles");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LinkWithRef = (0, _react.forwardRef)(_Link.default); // @ts-ignore

LinkWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  'aria-label': (0, _propTypes2.requireIf)(_propTypes.default.string, function (_ref) {
    var text = _ref.text;
    return (0, _isEmpty.default)(text);
  }),
  icon: _propTypes.default.elementType,
  text: (0, _propTypes2.requireIf)(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]), function (_ref2) {
    var icon = _ref2.icon;
    return (0, _isEmpty.default)(icon);
  })
});
LinkWithRef.defaultProps = {
  icon: undefined,
  iconPosition: 'left',
  size: 'medium',
  variant: 'normal'
};
LinkWithRef.displayName = 'Link';
var _default = LinkWithRef;
exports.default = _default;